import React from "react"
import ReactPaginate from "react-paginate"

function PaginationButton({ totalPage, handlePagination, linkColour }) {
  const classLinkColour = linkColour ? linkColour : ""
  return (
    <ReactPaginate
      previousLabel={<span uk-pagination-previous="true"></span>}
      nextLabel={<span uk-pagination-next="true"></span>}
      nextLinkClassName={"uk-button uk-button-text " + classLinkColour}
      previousLinkClassName={"uk-button uk-button-text " + classLinkColour}
      breakLabel={"..."}
      breakClassName={"uk-disabled"}
      pageCount={totalPage}
      marginPagesDisplayed={2}
      pageRangeDisplayed={3}
      onPageChange={handlePagination}
      containerClassName={"uk-pagination uk-flex-center uk-margin-large-bottom"}
      activeClassName={"uk-active"}
      pageLinkClassName={"uk-button uk-button-text " + classLinkColour}
    />
  )
}

export default PaginationButton
